<template>
  <div class="VideoMonitor">
    <div class="mask"></div>
    <div ref="videoList" class="videoList">
      <div
        v-for="(item, index) in urlList"
        :key="index"
        class="videoBox"
        :class="{
          noMargin: videoNum === 1,
          videoBox4: videoNum === 4,
          videoBox9: videoNum === 9,
        }"
      >
        <EZVideo
          ref="EZVideo"
          :url="item.url"
          :video-dom-id="item.videoDomId"
          :access-token="item.accessToken"
          :data-item="item"
        />
      </div>
    </div>
    <div v-if="urlList.length===0" class="tips">点击选择要播放的摄像机或录像机</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EZVideo from '../../../../../../device/monitor/real-time-monitor/EZVideo.vue'
import _ from 'lodash'

export default {
  components: { EZVideo },
  props: {
    propValue: {
      type: String,
      default: ''
    },
    areaId: {
      type: String,
      default: ''
    },
    element: {
      type: Object,
      default: () => {}
    },
    videoType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      urlList: [],
      accessToken: '',
      videoNum: 1,
      deviceList: [],
      videoIndex: 0,
      count: 0
    }
  },
  computed: {
    ...mapState({
      projectItem: (state) => state.user.projectItem
    })
  },
  watch: {
    element: {
      deep: true,
      handler() {
        this.getChanelList()
      }
    }
  },
  created() {
    this.videoNum = this.element.videoNum

    this.getChanelList = _.debounce(this.getChanelList, 300)
    if (this.videoType !== 1) {
      this.getChanelList()
    }
  },
  mounted() {},
  methods: {
    getChanelList() {
      console.log('deviceList', this.element.deviceList)
      this.deviceList = this.element.deviceList
      this.videoNumTap(this.videoNum)
    },
    videoNumTap(num, loop) {
      clearTimeout(this.timeoutTimer)
      if (!loop) {
        if (this.element.style.deviceType === 'NVR') {
          this.videoIndex = this.deviceList.findIndex(item => item.channelId === this.element.style.channelId)
        } else {
          this.videoIndex = this.deviceList.findIndex(item => item.deviceId === this.element.style.deviceId)
        }
      }
      let arr = []
      if (num === 1 || this.element.style.duration === 0) {
        arr = this.deviceList.slice(this.videoIndex, num + this.videoIndex)
      } else {
        if (this.videoIndex + num > (this.deviceList.length - 1)) {
          const firstArr = this.deviceList.slice(this.videoIndex)
          const secondIndex = (this.videoIndex + num) - (this.deviceList.length)
          const secondArr = this.deviceList.slice(0, secondIndex)
          console.log('firstArr', firstArr, secondArr)
          arr = firstArr.concat(secondArr)
          this.videoIndex = secondIndex
        } else {
          arr = this.deviceList.slice(this.videoIndex, num + this.videoIndex)
          this.videoIndex = this.videoIndex + num
        }
      }
      this.count++
      this.urlList = []
      this.$nextTick(() => {
        const emptyArr = []
        for (let index = 0; index < num; index++) {
          emptyArr.push({ url: '' })
        }
        this.urlList = emptyArr
      })
      // Promise.all(requestList).then(res => {

      // })
      this.timeoutTimer = setTimeout(() => {
        arr.forEach(item => {
          item.url = item.playHdLiveUrl
        })
        this.urlList = arr
        if (num !== 1 && this.element.style.duration !== 0) {
          this.setTimer()
        }
      }, 400)
    },
    setTimer() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.videoNumTap(this.videoNum, true)
      }, this.element.style.duration * 60 * 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.VideoMonitor {
  width: 100%;
  height: 100%;
  position: relative;
  .mask{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
  }
  .videoList {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    background: #fff;
    .videoBox {
      width: 100%;
      height: 100%;
    }
    .videoBox4 {
      width: 49%;
      height: 49%;
      margin-bottom: 1%;
      margin-right: 1%;
    }
    .videoBox9 {
      width: 33%;
      height: 33%;
      margin-bottom: 0.3%;
      margin-right: 0.3%;
    }
    .noMargin {
      margin-bottom: 0;
    }
  }
  .tips{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ff0000;
  }
}
</style>
